export class PropertyCfRequestModel {
  /**
 * The capForce user
 */
  capForceUser: string;

  /**
   * The city of the property
   */
  propertyCity: string;

  /**
   * The company name of the property
   */
  propertyCompanyName: string;

  /**
   * The horizon ID of the property
   */
  propertyHorizonId: string;

  /**
   * The latitude of the property
   */
  propertyLatitude: string;

  /**
   * The longitude of the property
   */
  propertyLongitude: string;

  /**
   * The MDM ID of the property
   */
  propertyMDMId: string;

  /**
   * The market submarket of the property
   */
  propertyMarketSubMarket: string;

  /**
   * The name of the property
   */
  propertyName: string;

  /**
   * The post code of the property
   */
  propertyPostCode: string;

  /**
   * The manual region of the property
   */
  propertyRegionManual: string;

  /**
   * The state, county, or province of the property
   */
  propertyStateCountyProvince: string;

  /**
   * The street of the property
   */
  propertyStreet: string;

  /**
   * The opportunity property ID
   */
  opportunityPropertyId: string;

  /**
   * Constructor
   * @param data Data
   * @param isCfProperty (Optional) Indicator showing whether the data is a capforce property
   * */
  constructor(data: any, isCfProperty = true) {
    if (data) {
      if (isCfProperty) {
        this.capForceUser = data.CapForceUser;
        this.propertyCity = data.PropertyCity;
        this.propertyCompanyName = data.PropertyCompanyName;
        this.propertyHorizonId = data.PropertyHorizonId;
        this.propertyLatitude = data.PropertyLatitude;
        this.propertyLongitude = data.PropertyLongitude;
        this.propertyMDMId = data.PropertyMDMId;
        this.propertyMarketSubMarket = data.PropertyMarketSubMarket;
        this.propertyName = data.PropertyName;
        this.propertyPostCode = data.PropertyPostCode;
        this.propertyRegionManual = data.PropertyRegionManual;
        this.propertyStateCountyProvince = data.PropertyStateCountyProvince;
        this.propertyStreet = data.PropertyStreet;
        this.opportunityPropertyId = data.OpportunityPropertyId;
      } else {
        this.capForceUser = data.OwnerUserIDDescription;
        this.propertyCity = data.PropertyStateCountyProvince;
        this.propertyCompanyName = data.propertyCompanyName;
        this.propertyHorizonId = data.propertyHorizonId;
        this.propertyLatitude = data.Latitude;
        this.propertyLongitude = data.Longitude;
        this.propertyMDMId = data.propertyMDMId;
        this.propertyMarketSubMarket = data.PropertyMarketSubMarket;
        this.propertyName = data.buildingName;
        this.propertyPostCode = data.PostalCodeManual;
        this.propertyRegionManual = data.RegionManual;
        this.propertyStateCountyProvince = data.PropertyStateCountyProvince;
        this.propertyStreet = data.Street1;
        this.opportunityPropertyId = data.opportunityPropertyId;
      }
    }
  }
}
